import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getDoneWorksPhotos: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].GET_DONE_WORKS_PHOTOS,
	},
	getDoneWorksPhotoPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].GET_DONE_WORKS_PHOTO_PREVIEW,
	},
	getDoneWorksPhotoPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].GET_DONE_WORKS_PHOTO_POPUP,
	},
	createDoneWorksPhoto: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].CREATE_DONE_WORKS_PHOTO,
	},
	getDoneWorksPhoto: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].GET_DONE_WORKS_PHOTO,
	},
	patchDoneWorksPhoto: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].PATCH_DONE_WORKS_PHOTO,
	},
	putDoneWorksPhoto: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].PUT_DONE_WORKS_PHOTO,
	},
	deleteDoneWorksPhoto: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].DELETE_DONE_WORKS_PHOTO,
	},
}